import { useEffect, useState } from "react";

export const EASE = [0.22, 1, 0.36, 1];

// Shared reveal variants — named after how a building goes up.
export const VARIANTS = {
  up: { hidden: { opacity: 0.001, y: 24 }, show: { opacity: 1, y: 0 } },
  rise: { hidden: { clipPath: "inset(100% 0 0 0)", y: 16 }, show: { clipPath: "inset(0% 0 0 0)", y: 0 } },
  wipe: { hidden: { clipPath: "inset(0 100% 0 0)" }, show: { clipPath: "inset(0 0% 0 0)" } },
  draft: { hidden: { opacity: 0.001, filter: "blur(8px)", y: 10 }, show: { opacity: 1, filter: "blur(0px)", y: 0 } },
};

export const useIsTouch = () => {
  const [touch, setTouch] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(hover: none), (pointer: coarse)");
    const update = () => setTouch(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);
  return touch;
};
